import { Currency } from './currency';

export interface Account {
  id: string;
  accountId: string;
  name: string;
  number: string;
  branchCode: string;
  balanceInReferenceCurrency: number;
  currency: Currency;
  status: string;
}

//TODO ItermediateAccount remove after reamke account logic everywhere
export interface ItermediateAccount {
  accountId: string;
  name: string;
  accountNumber: string;
  account: Account;
  displayed: boolean;
}

export interface UserAccount {
  accountId: string;
  name: string;
  accountNumber: string;
  account: {
    branchCode: any;
    balanceInReferenceCurrency: number;
    currency: Currency;
  };
  displayed: boolean;
}

export const initialUserAccount: ItermediateAccount = {
  accountId: '',
  name: '',
  accountNumber: '',
  account: {
    balanceInReferenceCurrency: 0,
    branchCode: '',
    currency: {
      id: '',
      alphabeticCode: '',
    },
    name: '',
    id: '',
    accountId: '',
    number: '',
    status: '',
  },
  displayed: true,
};

export const initialAccount: Account = {
  id: '',
  accountId: '',
  name: '',
  number: '',
  branchCode: '',
  balanceInReferenceCurrency: 0,
  currency: {
    id: '',
    alphabeticCode: '',
  },
  status: '',
};

export interface AccountForChange {
  id: string;
  displayed: boolean;
}
